import { formatDate, isDateAfterToday, isDateBeforeToday } from 'utils/moment';

export const EBOOK_ITEM = 'ebook';

export const convertEvent = item => ({
  id: item.event || item.id,
  name: item.event_name || item.name,
  description: item.event_description || item.description,
  startsAt: item.start_date,
  endsAt: item.end_date,
  thumbnail: item.event_poster || item.thumbnail,
  frontEndThumbnail: item.thumbnail_frontend,
  coverImages: [item.event_poster || item.thumbnail],
  venue: item.event_venue || item.venue,
  type: 'event',
  category: {
    id: item.event_category_fk,
    name: item.category_name
  },
  permalink: item.frontend_link || null,
  link: '',
  store: {
    id: item.store_fk || item.store,
    name: item.store_name
  },
  published: item.is_published || true,
  partialPayments: item.has_payment_installments || false,
  dataFields: item.data_fields,
  dataFieldNames: item.data_fields_names,
  tickets: convertItemCollection(item.tickets || [], 'TICKET_ITEM', item),
  payment: [
    {
      type: 'mobile',
      enabled: item.payments_mpesa || false
    },
    {
      type: 'card',
      enabled: item.payments_cards || false
    },
    {
      type: 'cash',
      enabled: item.payments_cash || false
    }
  ],
  currency: item.currency,
  country: item.country,
  typeName: item.type_name || '',
  isFree: item.is_free,
  hasStreams: item.has_streams,
  streams: item.streams || [],
  isLive: item.is_live,
  slug: item.slug,
  storeSlug: item.store_slug,
  event_terms_and_conditions: item.event_terms_and_conditions
});

export const convertItemCollection = (
  items,
  type,
  event,
  album,
  musicCurrency
) =>
  items.map((item, idx) =>
    convertItemType({ item, idx, type, event, album, musicCurrency })
  );

export const convertItemType = ({
  item,
  idx,
  type,
  event,
  album,
  musicCurrency
}) => {
  switch (type) {
    case 'TICKET_ITEM':
      return convertTicket(item, event);
    case 'TRACK_ITEM':
      return convertTrack({ item, idx, album, musicCurrency });
    case 'LIBRARY_TRACK':
      return convertLibraryTrack({ item, idx, album });
    default:
      return item;
  }
};

export const convertTicket = (item, event = null) => ({
  id: item.id,
  ticketableId: item.event_fk,
  ticketName: item.ticket_name,
  description: item.ticket_description,
  prices: item.prices,
  price:
    item.prices && item.prices.length === 1
      ? parseInt(item.prices[0].price, 10)
      : parseInt(item.ticket_value, 10),
  startsAt: item.start_at,
  endsAt: formatDate(item.end_at),
  isAvailable: item.is_available && item.is_published && item.is_active,
  soldOut: item.tickets_available <= 0,
  saleStart: isDateAfterToday(item.sales_start_at),
  saleEnd: !isDateBeforeToday(item.sales_end_at),
  isPublished: item.is_published,
  currency: item.selected_currency || 'KES',
  quantity: 0,
  minQuantity: 0,
  ticketIsFree: event.is_free,
  maxQuantity: item.id === 'd5076179-aa4e-4cd5-a7e8-02670a6d4717' ? 1 : 10,
  maxInstallments: item.payment_installments || 3,
  allowInstallments: event.has_payment_installments || false,
  payment: [],
  payments: [
    {
      type: 'mobile',
      enabled: (event && event.payments_mpesa) || false
    },
    {
      type: 'card',
      enabled: (event && event.payments_cards) || false
    },
    {
      type: 'cash',
      enabled: (event && event.payments_cash) || false
    }
  ],
  name: event.event_name,
  hasStreams: event.has_streams,
  slug: '/event/' + event.slug,
  typeName: item.type_name || '',
  thumbnail: item.thumbnail
});

export const convertAlbum = (item, albumPrice, musicCurrency) => ({
  id: item.item_id || item.id,
  name: item.name,
  description: item.description,
  thumbnail: item.thumbnail,
  frontEndThumbnail: item.thumbnail_frontend,
  coverImages: [item.thumbnail_frontend || item.thumbnail],
  publishDate: item.publish_date,
  currency: musicCurrency || item.currency || 'KES',
  country: item.country,
  mediaType: item.media_type_name,
  prices: item.prices ? item.prices : [],
  price:
    albumPrice && albumPrice.length
      ? parseInt(albumPrice[0].price, 10)
      : parseInt(item.price, 10),
  published: item.is_published || true,
  tracks: convertItemCollection(
    item.digital_medias || [],
    'TRACK_ITEM',
    '',
    item,
    musicCurrency
  ),
  selected: false,
  quantity: 1,
  maxQuantity: 1,
  store: {
    id: item.store,
    name: item.store_name || item.store
  },
  categories: [
    {
      id: item.category,
      name: item.category_name
    }
  ],
  authors: item.authors || [],
  payments: [
    {
      type: 'mobile',
      enabled: item.payments_mpesa || false
    },
    {
      type: 'card',
      enabled: item.payments_cards || false
    }
  ],
  typeName: item.type_name || '',
  amount: item.order_item_price,
  slug: '/album/' + item.slug,
  storeSlug: item.store_slug
});

export const convertLibraryAlbum = item => ({
  id: item.id,
  name: item.name,
  description: item.description,
  thumbnail: item.thumbnail,
  tracks: convertItemCollection(
    item.media_files || [],
    'LIBRARY_TRACK',
    '',
    item
  ),
  storeName: item.store_name,
  authors: item.authors || [],
  categoryName: item.category_name,
  type: item.content_type_name
});

export const convertLibraryTrack = ({ item, idx, album }) => ({
  trackNumber: idx,
  name: item.name,
  duration: 0,
  authors: item.authors || [],
  streamUrl: item.file,
  thumbnail: album.thumbnail
});

export const convertTrack = ({ item, idx, album, musicCurrency }) => ({
  album,
  id: item.id,
  trackNumber: idx,
  name: item.name,
  duration: 0,
  description: item.description,
  thumbnail: item.thumbnail,
  frontEndThumbnail: item.thumbnail_frontend,
  coverImages: [item.thumbnail_frontend],
  currency: musicCurrency || item.currency || 'KES',
  country: item.country,
  format: item.media_format,
  price:
    item.prices && item.prices.length
      ? album.id === '393ffdce-4657-41a6-a0bd-cf2d55b0e278'
        ? parseInt(150, 10)
        : parseInt(item.prices[0].price, 10)
      : parseInt(item.price, 10),
  prices: item.prices
    ? album.id === '393ffdce-4657-41a6-a0bd-cf2d55b0e278'
      ? [
          {
            price: '150.00',
            price_currency: 'KES'
          }
        ]
      : item.prices
    : [],
  streamUrl: item.media_player_url,
  publishDate: item.publish_date,
  quantity: 1,
  maxQuantity: 1,
  store: {
    id: item.store,
    name: item.store_name
  },
  categories: [
    {
      id: item.category,
      name: item.category_name
    }
  ],
  authors: item.authors || [],
  payments: [
    {
      type: 'mobile',
      enabled: item.payments_mpesa || false
    },
    {
      type: 'card',
      enabled: item.payments_cards || false
    }
  ],
  permalink: item.frontend_link,
  link: '',
  selected: false,
  typeName: item.type_name || '',
  slug: '/album/' + album
});

export const convertEbook = item => ({
  id: item.id,
  name: item.name,
  description: item.description,
  thumbnail: item.thumbnail,
  price: parseInt(item.get_price, 10),
  isAvailable: true,
  frontEndThumbnail: item.thumbnail_frontend,
  coverImages: [item.thumbnail || item.thumbnail_frontend],
  soldOut: false,
  publishDate: item.publish_date,
  isPublished: item.is_published,
  currency: item.selected_currency || 'KES',
  quantity: 1,
  maxQuantity: 1,
  // gallery: item.digital_medias[0].gallery.map(pic => pic.image),
  payment: [],
  store: {
    id: item.store,
    name: item.store_name || item.store,
    slug: item.store_slug
  },
  authors: item.authors,
  category: {
    id: item.category,
    name: item.category_name,
    type: item.category_type_name
  },
  mediaType: {
    id: item.media_type,
    name: item.media_type_name
  },
  // format: item.digital_medias.media_format,
  ebookFiles: item.digital_medias.map(file => convertEbookFiles(file, item)),
  payments: [
    {
      type: 'mobile',
      enabled: item.payments_mpesa || false
    },
    {
      type: 'card',
      enabled: item.payments_cards || false
    }
  ],
  type: EBOOK_ITEM,
  typeName: item.type_name || '',
  slug: '/ebook/' + item.slug
});

export const convertEbookFiles = (file, book) => ({
  id: file.id,
  name: file.name,
  price: file.price,
  format: file.media_format,
  gallery: file.gallery,
  maxQuantity: 10,
  quantity: 0,
  type: EBOOK_ITEM,
  thumbnail: book.thumbnail_frontend,
  payments: [
    {
      type: 'card',
      enabled: book.payments_cards || false
    },
    {
      type: 'mobile',
      enabled: book.payments_mpesa || false
    }
  ],
  typeName: file.type_name || ''
});
